import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import CardTitle from "@saleor/components/CardTitle";
import Clipboard from "@saleor/components/Clipboard";
import FormSpacer from "@saleor/components/FormSpacer";
import React from "react";

export interface DeepLinkProps {
  linkId: string;
  linkUrl: string;
  shortLinkUrl: string;
  onGenerateDeeplink: (id: string) => void;
}

const DeepLink: React.FC<DeepLinkProps> = ({
  linkId,
  linkUrl,
  shortLinkUrl,
  onGenerateDeeplink
}) => (
  <Card>
    <CardTitle title="Deeplink Details" />
    <CardContent>
      <Clipboard
        idClipboard="sellerID"
        label="Seller Id"
        value={linkId}
        onGenerate={() => undefined}
      />
      <FormSpacer />
      <Clipboard
        idClipboard="deeplinkURL"
        label="Deeplink URL"
        value={linkUrl}
        onGenerate={() => onGenerateDeeplink(linkId)}
      />
      <FormSpacer />
      <Clipboard
        idClipboard="shortDynamicURL"
        label="Short Dynamic URL"
        value={shortLinkUrl}
        onGenerate={() => onGenerateDeeplink(linkId)}
      />
    </CardContent>
  </Card>
);

export default DeepLink;
